import {ProductListFilterItemRangeValue} from "./ProductListFilterItemRange";
import {IAvailableFilter, IFilterValue} from "../items/interface/Item.interface";

export type ProductListFilterItemValueType = undefined | boolean | ProductListFilterItemRangeValue | string[];

export enum ProductListFilterItemType {
  select = "select",
  boolean = "bool",
  range = "range",
}

export interface IProductListFilterItem {
  /**
   * Number of available items with filter
   */
  count: number | undefined;

  /**
   * Type of filter input
   */
  readonly type: string;

  /**
   * Filter id
   */
  readonly field: string;

  /**
   * Filter name
   */
  readonly name: string | undefined;

  /**
   * Filter options
   */
  values: Map<string, IFilterValue>;

  /**
   * Set/Get filter value
   */
  value: ProductListFilterItemValueType;

  /**
   * Get value for search params
   */
  readonly paramValue: string;

  /**
   * Function to disable filter
   */
  disable(): void;

  /**
   * Apply filter result from request response
   * @param filterItemValueResults
   */
  applyFilterItemValueResult(filterItemValueResults: IFilterValue[]): void;

  /**
   * Function to reset filter value
   */
  clear(): void;

  /**
   * Function to convert filter item result to value of filter item.
   */
  getValueFromResult(filterItemData: IAvailableFilter): ProductListFilterItemValueType;

  /**
   * Function to convert filter item result to value of filter item.
   */
  applyFilterItemResult(filterItemData: IAvailableFilter): void;
}

export class ProductListFilterItem {
  public count: number | undefined;

  public readonly type: string;

  public readonly field: string;

  public readonly name: string | undefined;

  public values: Map<string, IFilterValue>;

  public constructor(filterItemData: IAvailableFilter) {
    this.count = filterItemData.count;
    this.type = filterItemData.type;
    this.field = filterItemData.field;
    this.name = filterItemData.name;
    this.values = new Map(
      filterItemData.values.map((value) => {
        return [value.id, value];
      }),
    );
  }

  public disable(): void {
    this.count = 0;
    this.values = new Map();
  }

  public applyFilterItemValueResult(filterItemValueResults: IFilterValue[]): void {
    const updatedFilterItemValue = new Set();

    // set new value count in new response
    for (const filterItemValueResult of filterItemValueResults) {
      this.values.set(filterItemValueResult.id, filterItemValueResult);
      updatedFilterItemValue.add(filterItemValueResult.id);
    }

    // reset others value count
    for (const [id, value] of this.values) {
      if (!updatedFilterItemValue.has(id)) {
        this.values.set(id, {
          ...value,
          count: 0,
        });
      }
    }
  }
}
